import * as React from 'react';

import { ListPerformanceProps } from '../../components/list/performance';
import ListProduction from '../../components/list/production';

const ListProdPerformanceView: React.StatelessComponent<ListPerformanceProps> = props => {
    console.log(props.performance)
    return (
        <li className="ace-production-row">
            <div className="ace-production-image">
                <div className="ace-production-image-inner">
                    <img src={props.performance.imageUrl} alt={props.performance.imageAltText} />
                </div>
            </div>
            <div className="ace-production-info">
                <div className="stack-md">
                    <h3 data-demo-label="Performance Title">
                        {
                            props.performance.productionDetailPageLink != null && props.performance.productionDetailPageLink.length > 0 ?
                                <a target="_blank" href={props.performance.productionDetailPageLink} dangerouslySetInnerHTML={{ __html: props.performance.title }} />
                                :
                                <span dangerouslySetInnerHTML={{ __html: props.performance.title }} />
                        }
                    </h3>
                    <div>
                        <p>
                            {props.performance.performanceDateDayString} at {props.performance.performanceTimeString}
                        </p>
                        <p className="light">
                            <span>{props.performance.facility.facilityDescription}</span>
                        </p>
                    </div>
                </div>
            </div>


        </li>
    );
}

export default ListProdPerformanceView;